import React, {useState} from 'react';
import cl from "../BaseSimplePage/BaseSimplePage.module.css";
import SubscriptionCancellationsSummaryBrowser from "./SubscriptionCancellationsSummaryBrowser";
import SubscriptionCancellationsSummaryEditor from "./SubscriptionCancellationsSummaryEditor";

const SubscriptionCancellationsSummarySubPage = ({isAddSubMode}) => {

    const [summaryData, setSummaryData] = useState(null);

    return (
        <div className={cl.main0}>
            <div className={cl.mainRow}>
                {!isAddSubMode && <div className={cl.browserArea} style={undefined}>
                    <SubscriptionCancellationsSummaryBrowser
                        setSummaryData={setSummaryData}
                    />
                </div>}
                <div className={cl.editorArea}>
                    <SubscriptionCancellationsSummaryEditor
                        summaryData={summaryData}
                    />
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCancellationsSummarySubPage;